import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import * as Enums from '../../../../../Autofacets-Core/src/app/utils/enums';
import { DealerHolidayViewModel } from '../../business-entities/dealer-holiday-list-view-model';
import { DealerOpeningHoursViewModel } from '../../business-entities/dealer-opening-hours-view-model';
import { Features } from '../../business-entities/user-role-view-model';
import { EditAppointmentService } from '../../business-services/edit-appointment.service';
import { Utility } from './../../../../../Autofacets-Core/src/app/utils/utility';
import { GenericSchedulerListViewModel } from './../../business-entities/generic-scheduler-list-view-model';
import { SaveAppointmentPlanning } from './../../business-entities/save-appointment-planning.model';
import { AppointmentPlanningService } from './../../business-services/appointment-planning.service';
import { AddBookingComponent } from './../../views/appointment/edit-appointment/appointment-planning/add-booking/add-booking.component';
import * as moment from 'moment';

const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

const weekEnds = [0, 6];
const dayNames = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

@Component({
  selector: 'app-af-scheduler-list',
  templateUrl: './scheduler-list.component.html',
  styleUrls: ['./scheduler-list.component.css']
})
export class SchedulerListComponent implements OnInit {

  @Input() dealerHolidays: DealerHolidayViewModel[] = [];
  @Input() dealerWorkingHours: DealerOpeningHoursViewModel[] = [];
  @Input() genericSchedulerList: GenericSchedulerListViewModel[] = [];
  @Input() selectedDate: Date;
  @Input() appointmentDate: Date;
  @Output() showAllMechanics = new EventEmitter<boolean>();
  // @Output() showAddBooking = new EventEmitter<{ isSave: any, month: number, year: number }>();
  @Output() showAddBooking = new EventEmitter<boolean>();
  @Output() nextAvialSlotForMechanic = new EventEmitter<number>();
  @Input() unavailableDates: Array<string>;
  @Input() endTime: string;
  @Input() selectedAppointmentMechanicId: number;
  isShowAll: boolean = false;
  lang: string = 'en-US';
  @Input() appointmentId: number;
  @Input() dealerId: number;
  @Input() duration: number;
  @Input() isViewAppointment: boolean = false;
  @Input() isServicesAdded: boolean = true;
  //Added by Bhavesh
  @Input() schedularHeader: any; //Added by Bhavesh on 06 aug 2021
  @Output() onDayChange = new EventEmitter<Date>();
  @Output() onMonthChange = new EventEmitter<Date>();
  @Input() schedulerModal:any;
  @Input() isView:boolean;
  @Input() isReadOnly: boolean;
  @Input() isScheduleSummary: boolean;
  @Input() distinctDealers: any;
  @Input() dealerdata: any;
  @Input() onScrollPlanning: { scrollTop: number; scrollLeft: number } = { scrollTop: 0, scrollLeft: 0 };
  @Output() onMechanicScroll = new EventEmitter<number>();
  @ViewChild('leftScroller', { static: false }) leftScrollerElement: ElementRef<HTMLElement>;
  @ViewChild('headerStickyRef', { static: false }) headerStickyRef!: ElementRef<HTMLElement>;
  isSyncingScroll: boolean = false;
  availbleHour:string;
  availbleDateTime:any;
  schedularHeaderInfo: any;
  BookedWarningPerc = 80;
  BookedCriticalPerc = 90;
  monthsInfo: any;
  currentDay: any;
  hour:any = 0;
  dealerName='';
  monthDays: any;
  showMonth:any;
  features: Features[] = [];
  isGrayHeaderBorder = false;
  constructor(
    private model: NgbModal,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private readonly editAppointmentService: EditAppointmentService,
    private appointmentPlanningService: AppointmentPlanningService,
    private secureStorage: SecureStorage,
  ) { }

  ngOnInit(): void {
    this.isGrayHeaderBorder = localStorage.getItem("Theme") === 'mg';
    this.OnClickShowAll();
    if(!this.isView){
      this.dealerName = this.editAppointmentService.appointmentDetails.dealerName;
    }
    this.schedularHeaderDataMapper(new Date(this.selectedDate),this.schedularHeader, new Date(this.selectedDate));
    this.setTime();
    this.monthDays = this.onGetCurrentMonthDates(new Date(this.selectedDate));
  }

  ngOnChanges(): void {
    this.getPlanningCommonMonthInfo(this.schedularHeader, new Date(this.selectedDate), new Date(this.selectedDate));
    this.reloadHeaderData();
    this.setTime();
    this.monthDays = this.onGetCurrentMonthDates(new Date(this.selectedDate));

    if (this.leftScrollerElement?.nativeElement && this.onScrollPlanning) {
      this.isSyncingScroll = true;
      this.leftScrollerElement.nativeElement.scrollTop = this.onScrollPlanning.scrollTop;
    }

    setTimeout(() => {
      if (this.headerStickyRef?.nativeElement) {
        const height = this.headerStickyRef.nativeElement.offsetHeight;
        if (height > 0) {
          document.documentElement.style.setProperty('--planner-header-sticky-height', height + 'px');
        }
      }
    }, 0);
  }

  onMechanicListScroll(event: Event): void {
    if (this.isSyncingScroll) {
      this.isSyncingScroll = false;
      return;
    }
    const el = event.target as HTMLElement;
    this.onMechanicScroll.emit(el.scrollTop);
  }
  ngAfterViewInit(): void {
    const element = document.getElementById('scrollToMe');
    if(element){
      element.scrollIntoView({ block: 'nearest', inline: 'center' });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    if (this.headerStickyRef?.nativeElement) {
      const height = this.headerStickyRef.nativeElement.offsetHeight;
      document.documentElement.style.setProperty('--planner-header-sticky-height', height + 'px');
    }
  }
formatTimeRange(start,end){
  return (start ? Utility.ConvertUTCDateToLocalTime(start) : '00:00') +
  '-' +
  (end ? Utility.ConvertUTCDateToLocalTime(end) : '00:00');
}
normalizeTimeRange(timeRange) {
  return timeRange === 'null-null' ? '00:00-00:00' : timeRange;
}
  
  private setTime(){
    this.hour = 0;
    this.genericSchedulerList?.forEach((element)=>{
      let arr = this.schedulerModal?.planningResources?.filter(x=>x.mechanicId === element.pId)[0];
      let arrEvents = this.schedulerModal?.planningEvents?.filter(x=>x.mechanicId === element.pId)
      if(!arr || !arrEvents){
        element.totalHour = 0;
        element.bookedHour = 0;
        element.shiftTime = null;
        element.lunchTime = null;
        element.bookedHourDateTime = '00:00';

      }
      else{
        element.totalHour = this.calculateTotalWorkingHours(arr?.shiftInfo.shiftTime, arr?.shiftInfo.lunchTime, arr?.shiftInfo.break1Time, arr?.shiftInfo.break2Time, arr?.shiftInfo.notAvailableData,arr?.shiftInfo.leaveData).toFixed(2);
        let minutesArr = arrEvents?.map(x=>x.duration);
        element.bookedHour = (minutesArr?.reduce((partialSum, a) => partialSum + a, 0)/60).toFixed(2);
        element.shiftTime = this.formatTimeRange(arr?.shiftInfo.shiftTime?.start, arr?.shiftInfo.shiftTime?.end)
        element.lunchTime = this.formatTimeRange(arr?.shiftInfo.lunchTime?.start, arr?.shiftInfo.lunchTime?.end)
        element.lunchTime = this.normalizeTimeRange (element.lunchTime );
        element.shiftTime = this.normalizeTimeRange(element.shiftTime );
        if(element?.isCapacityPlanning){
          this.hour = +(((element.totalHour - element.bookedHour) + this.hour).toFixed(2));
        }
        element.skillDescription = (element.skillDescription === '') ? null : element.skillDescription;
      }

    })
    let [h,m] = this.hour.toString().split('.');
    h = h ?? "0";
    m = m ?? "0"; 
    this.availbleDateTime = new Date();
    this.availbleDateTime.setHours(h);
    this.availbleDateTime.setMinutes(m);
  }
  private getPlanningCommonMonthInfo(monthsData: any, cDate: any, sDate: any) {
    let result = monthsData;
    this.monthsInfo = result;
    this.schedularHeaderDataMapper(new Date(cDate), result, new Date(sDate));
  }
  private calculateTotalWorkingHours(shift: any, lunch: any, break1: any, break2: any, notAvailableData: any, leaveData: any) {
    let shiftHours = Number.parseFloat(this.calculateTimeDiff(new Date(shift?.start), new Date(shift?.end))).toFixed(2);
    let lunchHours = Number.parseFloat(this.calculateTimeDiff(new Date(lunch?.start), new Date(lunch?.end))).toFixed(2);
    let break1Hours = Number.parseFloat(this.calculateTimeDiff(new Date(break1?.start), new Date(break1?.end))).toFixed(2);
    let break2Hours = Number.parseFloat(this.calculateTimeDiff(new Date(break2?.start), new Date(break2?.end))).toFixed(2);


    let response = +(Number.parseFloat(shiftHours) - Number.parseFloat(lunchHours) - Number.parseFloat(break1Hours) - Number.parseFloat(break2Hours)).toFixed(2);
    let lunchDeducted: boolean = false;
    let break1Deducted: boolean = false;
    let break2Deducted: boolean = false;
    let notAvailableHour;
    if (notAvailableData?.isNotAvailable) {
      notAvailableHour = Number.parseFloat(this.calculateTimeDiff(new Date(notAvailableData?.notAvailableStartTime), new Date(notAvailableData?.notAvailableEndTime))).toFixed(2);

      if (leaveData?.isOnLeave && !notAvailableData.isIncludedLeaveTime){
        if (new Date(leaveData?.leaveStartTime) < new Date(notAvailableData?.notAvailableEndTime)
          && new Date(leaveData?.leaveStartTime) > new Date(notAvailableData?.notAvailableStartTime)) {
          let suffixTime = Number.parseFloat(this.calculateTimeDiff(new Date(leaveData?.leaveStartTime), new Date(notAvailableData?.notAvailableEndTime))).toFixed(2);
          if (Number.parseFloat(suffixTime) > 0) {
            response += Number.parseFloat(suffixTime);
          }
        }
        if (new Date(leaveData?.leaveEndTime) < new Date(notAvailableData?.notAvailableEndTime)
          && new Date(leaveData?.leaveEndTime) > new Date(notAvailableData?.notAvailableStartTime)) {
          let suffixTime = Number.parseFloat(this.calculateTimeDiff(new Date(notAvailableData?.notAvailableStartTime), new Date(leaveData?.leaveEndTime))).toFixed(2);
          if (Number.parseFloat(suffixTime) > 0) {
            response += Number.parseFloat(suffixTime);
          }
        }
      }
      else if(notAvailableData.isIncludedLeaveTime){
        let includedTime = Number.parseFloat(this.calculateTimeDiff(new Date(leaveData?.leaveStartTime), new Date(leaveData?.leaveEndTime))).toFixed(2);
        response += Number.parseFloat(includedTime);
      }

      //remove lunch timing if it's included in not avilable range
      if (notAvailableData?.isIncludedLunchTime){
        lunchDeducted=true;
        notAvailableHour = (Number.parseFloat(notAvailableHour.toString()) - Number.parseFloat(lunchHours)).toFixed(2);
      }

      //remove break1 timing if it's included in not avilable range
      if (notAvailableData?.isIncludedBreak1Time){
        break1Deducted=true;
        notAvailableHour = (Number.parseFloat(notAvailableHour.toString()) - Number.parseFloat(break1Hours)).toFixed(2);
      }

      //remove break2 timing if it's included in not avilable range
      if (notAvailableData?.isIncludedBreak2Time){
        break2Deducted=true;
        notAvailableHour = (Number.parseFloat(notAvailableHour.toString()) - Number.parseFloat(break2Hours)).toFixed(2);
      }

      //update response deduct not available hours
      response = (+(Number.parseFloat(response.toString()) - Number.parseFloat(notAvailableHour)).toFixed(2) < 0) ? 0 : +(Number.parseFloat(response.toString()) - Number.parseFloat(notAvailableHour)).toFixed(2);
      // return response;
    }

    let leaveHour;
    if (leaveData?.isOnLeave) {
      leaveHour = Number.parseFloat(this.calculateTimeDiff(new Date(leaveData?.leaveStartTime), new Date(leaveData?.leaveEndTime))).toFixed(2);

      //remove lunch timing if it's included in leave range
      if (leaveData?.isIncludedLunchTime && !lunchDeducted){
        leaveHour = (Number.parseFloat(leaveHour.toString()) - Number.parseFloat(lunchHours)).toFixed(2);
      }

      //remove break1 timing if it's included in leave range
      if (leaveData?.isIncludedBreak1Time && !break1Deducted){
        leaveHour = (Number.parseFloat(leaveHour.toString()) - Number.parseFloat(break1Hours)).toFixed(2);
      }

      //remove break2 timing if it's included in leave range
      if (leaveData?.isIncludedBreak2Time && !break2Deducted){
        leaveHour = (Number.parseFloat(leaveHour.toString()) - Number.parseFloat(break2Hours)).toFixed(2);
      }

        //update response deduct leave hours
      response = (+(Number.parseFloat(response.toString()) - Number.parseFloat(leaveHour)).toFixed(2) < 0) ? 0 : +(Number.parseFloat(response.toString()) - Number.parseFloat(leaveHour)).toFixed(2);
      // return response;
    }

    if (!isNaN(+(response).toFixed(2))) {
      return +(response).toFixed(2);
    }
    else {
      return 0;
    }


  }

/**
* Calucate time difference between two dates
* @param start
* @param end
*/
private calculateTimeDiff(start: any, end: any): any {
let baseDiff = (end - start);
return (baseDiff % 86400000) / 3600000;
}
  private schedularHeaderDataMapper(cDate: Date, monthsInfo: any, sDate: Date) {
    if(monthsInfo){
     const currentDate = new Date(cDate);
     const superObject = Object();
     let x = monthsInfo.find(a => (new Date(a.monthOfDate).toLocaleDateString()) === (new Date(cDate).toLocaleDateString()));
     this.availbleHour = (x?.availableHours - x?.plannedHours).toString();
     this.availbleDateTime = new Date();
     if((x?.availableHours - x?.plannedHours) > 0){
      const [h,m] = this.availbleHour.split('.');
      this.availbleDateTime.setHours(h);
      this.availbleDateTime.setMinutes(m);
     }
     else{
      this.availbleDateTime.setHours(0);
      this.availbleDateTime.setMinutes(0);
     }
     superObject.currentMonth = `${monthNames[currentDate.getMonth()]}`;
     superObject.currentYear =`${currentDate.getFullYear()}`;
     this.currentDay = `${weekDays[currentDate.getDay()]}, ${monthNames[currentDate.getMonth()]} ${currentDate.getDate()}`;

     const supperArry = [];
     const monthAllDates = this.onGetCurrentMonthDates(cDate);
     const mechanicTotalMonthsPlan = monthsInfo;

     for (const monthDate of monthAllDates) {
       const single = Object();
       single.rentalCars = [];
       let mechanicDayWisePlanned = mechanicTotalMonthsPlan.find(y => (new Date(y.monthOfDate).toLocaleDateString()) === (new Date(monthDate).toLocaleDateString()));

       // calculate is week ends
       single.isHoliday = false;


       single.dayName = dayNames[new Date(monthDate).getDay()];
       single.actualDate = monthDate;
       single.cdate = new Date(monthDate).getDate();

       if (mechanicDayWisePlanned) {
        if(!mechanicDayWisePlanned.open)
        {
         single.isHoliday = true;
        }
         single.plannedHours = mechanicDayWisePlanned.plannedHours;
         single.availableHours = mechanicDayWisePlanned.availableHours;

         let colorStatus = this.defineHeaderColorAsPerRatio(mechanicDayWisePlanned);

         single.rationClass = !single.isHoliday ? colorStatus.color : '';


       }

       // set custom class to
       single.isCurrent = false;
       let selectedDate = this.datePipe.transform(new Date(sDate), 'yyyy/MM/dd');
       let monthsDate = this.datePipe.transform(new Date(monthDate), 'yyyy/MM/dd');

       if ((new Date(monthsDate).toLocaleDateString() === new Date(selectedDate).toLocaleDateString())) {
         single.classToSet = 'state-3'
         single.isCurrent = false;
       }

       supperArry.push(single);
     }

     superObject.infos = supperArry;
     this.schedularHeaderInfo = superObject;
     this.showMonth = moment(cDate).format("MMMM-YYYY");
    }
 }

  /**
    * Purpose of the method to create whole month dates based on current date
    * @param cDate
    */
  private onGetCurrentMonthDates(cDate: Date): any[] {
    const currentD = new Date(cDate);
    const month = currentD.getMonth();
    currentD.setDate(1);
    const alldays = [];
    while (currentD.getMonth() === month) {
      const calyear = currentD.getFullYear();
      const calmonth = (currentD.getMonth() + 1).toString().padStart(2, '0');
      const caldate = currentD.getDate().toString().padStart(2, '0');
      const d = `${calyear}-${calmonth}-${caldate}`;
      alldays.push(d);
      currentD.setDate(currentD.getDate() + 1);
    }

    return alldays;
  }

  /**
   * Purpose of the method to find calendar header color as pe ration
   * @param ratioInfo
   */
  private defineHeaderColorAsPerRatio(ratioInfo: any): any {
    let finds = Object();
    let findcolor = '';
    // calculate total booked hours in %

    if ((Number.parseFloat(ratioInfo.plannedHours) > 0
      && Number.parseFloat(ratioInfo.availableHours) > 0)) {

      let bookedRatio = ((Number.parseFloat(ratioInfo.plannedHours) / Number.parseFloat(ratioInfo.availableHours)) * 100)
      if (bookedRatio >= Number(this.BookedCriticalPerc)) {
        finds.color = 'booked-high';
      }
      else if (bookedRatio >= Number(this.BookedWarningPerc)) {
        finds.color = 'booked-medium';
      }
      else {
        finds.color = 'booked-low';
      }
      finds.holiday = false;
    }
    else if ((Number.parseFloat(ratioInfo.plannedHours) == 0
      && Number.parseFloat(ratioInfo.availableHours) > 0)) {
      finds.color = 'booked-low';
      finds.holiday = false;
    }
    else {
      finds.color = '';
      finds.holiday = true;
    }

    return finds;
  }

  OnClickShowAll() {
    this.showAllMechanics.emit(this.isShowAll);
  }
  /**
  * Method to captcher day click event
  * @param event
  */
  onDayClick(event) {
    // set date
    this.onDayChange.emit(event);
    this.reloadHeaderData();
  }


  onChangeDate(event){
    this.showMonth = moment(event).format("MMMM-YYYY");
    this.onMonthChange.emit(new Date(event));
    this.selectedDate = new Date(event);
    this.reloadHeaderData();
  }

     /**
     * Planner Previous button click
     */
      onSchedulerPreviousClick() {
        this.spinner.show();
        const element = document.getElementsByClassName('monthScrollDiv');
        if(element.length >0){
          element.item(0).scrollIntoView({ block: 'nearest' });
        }
        let currentDate = new Date(this.selectedDate);
        currentDate = new Date(currentDate.getFullYear(), (currentDate.getMonth() - 1), 1);
        this.onMonthChange.emit(new Date(currentDate));
        this.selectedDate = new Date(currentDate);
        // update current date
        this.reloadHeaderData();
      }

  /**
   * Planner next button click
   */
 /**
     * Planner next button click
     */
  onSchedulerNextClick() {
    this.spinner.show();
    const element = document.getElementsByClassName('monthScrollDiv');
    if(element.length >0){
      element.item(0).scrollIntoView({ block: 'nearest' });
    }
    let currentDate = new Date(this.selectedDate);
    currentDate = new Date(currentDate.getFullYear(), (currentDate.getMonth() + 1), 1);  
    this.onMonthChange.emit(new Date(currentDate));
    this.selectedDate = new Date(currentDate);
    // update current date
    this.reloadHeaderData();
  }

  private reloadHeaderData(){
    if (this.schedularHeaderInfo){
      this.schedularHeaderInfo.infos.forEach(element => {
        if (new Date(element.actualDate).toLocaleDateString() == new Date(this.selectedDate).toLocaleDateString()) {
          element.isCurrent = true;
          element.rationClass = !element.isHoliday ? this.defineHeaderColorAsPerRatio(element).color : '';
        }
        else {
          element.isCurrent = false;
          element.classToSet = '';
        }
      });
    }

  }
  AddPlanningPopup(pId, pText, startTime) {
    const modalref = this.model.open(AddBookingComponent, { size: 'lg', windowClass: 'pop-wid1200' });
    modalref.componentInstance.mechanicName = pText;
    modalref.componentInstance.startDate = this.selectedDate;
    modalref.componentInstance.pId = pId;
    modalref.componentInstance.durationValue = this.duration;
    modalref.componentInstance.unavailableDates = this.unavailableDates;
    modalref.componentInstance.endTime = this.endTime;
    modalref.componentInstance.dealerId = this.dealerId;
    modalref.componentInstance.mechanicStartTime = startTime;
    modalref.componentInstance.dealerWorkingHours = this.dealerWorkingHours;
    modalref.componentInstance.dealerHolidays = this.dealerHolidays;
    modalref.componentInstance.isServicesAdded = this.isServicesAdded;
    modalref.componentInstance.calenderStartDate = Utility.GetFormattedDate(this.appointmentDate);
    modalref.componentInstance.isServicesAdded = this.isServicesAdded;
    modalref.componentInstance.moduleId =  Enums.ModuleNames.Appointment;
    modalref.componentInstance.integrationWithDMS = false;
    modalref.componentInstance.realtimeDmsSyncAppointment = false;
    modalref.componentInstance.isAddBooking = true;
    this.features = this.secureStorage.getKeyData('feature');
    if (this.features?.length > 0) {
      modalref.componentInstance.integrationWithDMS = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
      modalref.componentInstance.realtimeDmsSyncAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
    }
    modalref.componentInstance.saveAppointmentBooking = async (mechanicPlanningViewModel: SaveAppointmentPlanning) => {
      this.spinner.show();
      mechanicPlanningViewModel.appointmentId = this.appointmentId;
      mechanicPlanningViewModel.mechanicId = pId;


      await this.appointmentPlanningService.saveAppointmentPlanning(mechanicPlanningViewModel)
        .then((response) => {
          this.spinner.hide();
          if (response) {
            const errorObject = response.responseObject.result;
            const msg = this.appointmentPlanningService.bookingErrorMessage(errorObject.errorCode);
            this.toastr.error(this.translate.instant(msg))
          } else {
            this.toastr.success(fromEnums.ToastrMessages.SaveMechanicBooking);
            this.showAddBooking.emit(true);
            modalref.close();
          }
        });
    }

  }
 
}
